import { MeetingsScheduleSlotInterface } from "@api/models/interfaces/meetings-schedule/MeetingsScheduleSlotInterface";
import { MeetingsSchedule } from "@api/models/meetings-schedule/MeetingsSchedule";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { UserProfile } from "@api/models/UserProfile";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { UserRepository } from "@api/repositories/UserRepository";

import { scheduleSchemaId, scheduleSlotSchemaId } from "./types/SchemaIds";

export interface MScheduleDataLoaderInterface {
    fetchRootSchedules(eventId: string): Promise<MeetingsSchedule[] | undefined>;
    fetchSchedules(parentScheduleId: string): Promise<MeetingsSchedule[] | undefined>;
    fetchSlots(scheduleIds: string[]): Promise<MScheduleSlot[] | undefined>;
    fetchProfiles(userIds: number[]): Promise<UserProfile[]>;
}

export class MScheduleDataLoader implements MScheduleDataLoaderInterface {

    private usersRepository: UserRepository;
    private objectRepository: ObjectRepository;

    constructor(repositories: RepositoryFabric, private groupFilter: any) {
        this.usersRepository = repositories.get(RepositoryFabric.USER) as UserRepository;
        this.objectRepository = repositories.get(RepositoryFabric.OBJECT) as ObjectRepository;
    }

    async fetchRootSchedules(eventId: string) {

        const where = {
            eventId: eventId,
            parentId: null,
            ...this.groupFilter
        }

        return this.fetchSchedulesByQuery(where);
    }

    async fetchSchedules(parentScheduleId: string): Promise<MeetingsSchedule[] | undefined> {
        const where = {
            parentId: parentScheduleId,
            ...this.groupFilter
        }

        return this.fetchSchedulesByQuery(where);
    }

    private async fetchSchedulesByQuery(query: any) {
        try {
            const result = (await this.objectRepository.query(scheduleSchemaId, {
                take: -1,
                where: query,
                include: ["id", "userIds", "parentId", "meetingsId", "slotSize", "eventId", "from", "to"],
                order: {
                    from: 'asc'
                }
            }))?.map((schedule) => new MeetingsSchedule(schedule))

            return result;
        }
        catch (error) {
            console.error(error);
        }
    }

    async fetchSlots(scheduleIds: string[]): Promise<MScheduleSlot[] | undefined> {

        try {
            const result = (await this.objectRepository.query(scheduleSlotSchemaId, {
                take: -1,
                where: {
                    scheduleId: {
                        $in: scheduleIds
                    }
                },
                order: {
                    beginAt: 'asc'
                }
            }))?.map((slot: MeetingsScheduleSlotInterface) => new MScheduleSlot(slot))

            return result || [];
        }
        catch (error) {
            console.error(error);
        }
    }

    async fetchProfiles(userIds: number[]): Promise<UserProfile[]> {
        const profiles = await this.usersRepository.profiles({
            where: {
                userId: {
                    $in: userIds
                }
            },
            // include: ,
            skip: 0,
            take: -1
        });

        return profiles
    }
}